import { __assign, __rest } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import PaywallLayout from './PaywallLayout';
import { getDeviationType } from '../../../_helpers';
import { DeviationTypes } from '../../../../types/deviation';
import { ProfileOwnerWatchButton } from '../../../../Button';
import paywallStyles from './Paywall.scss';
var textKeyForDeviationType = function (type) {
    if (type === DeviationTypes.LITERATURE) {
        return 'deviationview.paywall.artstage.watchersOnly.text.literature';
    }
    if (type === DeviationTypes.FILM) {
        return 'deviationview.paywall.artstage.watchersOnly.text.video';
    }
    return 'deviationview.paywall.artstage.watchersOnly.text';
};
var WatchersOnlyPaywall = function (_a) {
    var author = _a.deviation.author, deviation = _a.deviation, props = __rest(_a, ["deviation", "deviation"]);
    var t = useTranslation().t;
    return (React.createElement(PaywallLayout, __assign({ deviation: deviation, icon: React.createElement("div", { className: paywallStyles['watchers-icon'] }), title: t('deviationview.paywall.artstage.watchersOnly.title'), text: t(textKeyForDeviationType(getDeviationType(deviation))), button: author && (React.createElement(ProfileOwnerWatchButton, { className: paywallStyles['watch-button'], user: author, fullWidth: false, onToggleWatchSuccess: function () {
                window.location.href = deviation.url;
            } })) }, props)));
};
WatchersOnlyPaywall.displayName = 'WatchersOnlyPaywall';
export default WatchersOnlyPaywall;
//# sourceMappingURL=WatchersOnlyPaywall.js.map